import React, { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import Editor from "@component/UI/TMEditor";

import Loading from "@component/UI/Loading";

export default () => {
    const navigate = useNavigate();
    const { site, iam } = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(true);
    const [cfg, setCfg] = useState([]);
    const [terms, setTerms] = useState(null);
    const [data, setData] = useState(null);

    const loadConfig = () => {
        _API.get({ path: "/site/member/config" })
            .then((res) => {
                const { cfg, terms, infor } = res.data;
                setCfg(cfg);
                setTerms(terms);
                setData(infor);
                setIsLoading(false);
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    useEffect(() => {
        if (site?.siteCode) {
            loadConfig();
        }
    }, [site?.siteCode]);

    const getElement = () => {
        const result = [];
        for (let i in cfg) {
            const c = cfg[i];
            if (data?.country !== "KR" && c.isKor === "Y") {
                continue;
            }

            if (data?.[c.name] && typeof data?.[c.name] === "object") {
                result.push(
                    <tr key={i}>
                        <th>
                            {c?.isMust === "Y" && <strong className="txt_red">*</strong>}
                            {c?.title}
                        </th>
                        <td colspan="3">
                            {data?.[c.name] && data?.[c.name]?.join(",")} {data?.[c.name + "Others"] && `(${data?.[c.name + "Others"]})`}
                        </td>
                    </tr>
                );
            } else {
                result.push(
                    <tr key={i}>
                        <th>
                            {c?.isMust === "Y" && <strong className="txt_red">*</strong>}
                            {c?.title}
                        </th>
                        <td colspan="3">
                            {data?.[c.name]} {data?.[c.name + "Others"] && `(${data?.[c.name + "Others"]})`}
                        </td>
                    </tr>
                );
            }
        }

        return result;
    };

    if (!_CK.isLogin()) {
        swal("Please Login first.").then(() => {
            document.location.href = "/";
        });

        return;
    }

    return (
        <Fragment>
            {isLoading && <Loading />}
            <div className="contents">
                {site?.naviMypage && parse(site?.naviMypage)}

                <div className="right">
                    <div className="contentsTop">
                        <h3>Personal Information</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>Personal Information</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <div className="boxTable">
                            <span className="">
                                (<strong className="txt_red">*</strong> Indicates Required Field)
                            </span>

                            <table className="tbl_signup ">
                                <tr>
                                    <th width="24%">
                                        <strong className="txt_red">*</strong> ID (Email Address)
                                    </th>
                                    <td colspan="3">{data?.id}</td>
                                </tr>
                                <tr>
                                    <th>
                                        <strong className="txt_red">*</strong> First Name
                                    </th>
                                    <td width="28%">{data?.nameFirst}</td>
                                    <th width="20%">
                                        <strong className="txt_red">*</strong> Last Name
                                    </th>
                                    <td>{data?.nameLast}</td>
                                </tr>
                                {site?.lang !== "KOR" && (
                                    <tr>
                                        <th>
                                            <strong className="txt_red">*</strong> Country
                                        </th>
                                        <td colSpan={3}>{_DEF.getDefinedLabel(_DEF.COUNTRY, data?.country)}</td>
                                    </tr>
                                )}
                                {getElement()}
                            </table>
                            <div className="btnArea1">
                                <button type="submit" className="btn1 btnBlue1" onClick={() => navigate("/mypage/modify")}>
                                    Modify
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
